import { Visibility } from "@mui/icons-material";
import { Tooltip, Typography } from "@mui/material";
import React from "react";
import CircularLoading from "../../../../commons/loadingData/circularLoading";
import { StyledAttentionsInAnotherPtovidersCards } from "../../../../styled/providers";

const AttentionsInAnotherProviderCards = ({
  data,
  loading,
  generateAttentionInAnotherProviderHTML,
}) => {
  return (
    <StyledAttentionsInAnotherPtovidersCards.Container>
      {loading ? (
        <CircularLoading />
      ) : data.length ? (
        data.map((attention) => {
          return (
            <StyledAttentionsInAnotherPtovidersCards.Card
              key={`${attention.siniestro}-${attention.nroFormulario}`}>
              <Typography variant="body2">
                {attention.formularios[0].fechaDesde} -{" "}
                {attention.formularios[0].fechaHasta}
              </Typography>
              <Tooltip
                title="Ver atención"
                onClick={() =>
                  generateAttentionInAnotherProviderHTML(attention)
                }>
                <StyledAttentionsInAnotherPtovidersCards.Button>
                  <Visibility />
                </StyledAttentionsInAnotherPtovidersCards.Button>
              </Tooltip>
            </StyledAttentionsInAnotherPtovidersCards.Card>
          );
        })
      ) : (
        <StyledAttentionsInAnotherPtovidersCards.EmptyState variant="body2">
          No hay atenciones disponibles
        </StyledAttentionsInAnotherPtovidersCards.EmptyState>
      )}
    </StyledAttentionsInAnotherPtovidersCards.Container>
  );
};

export default AttentionsInAnotherProviderCards;
